import { workflowStatusMap } from '@shared/schema/workflowStatusMap.js';

const StatusMarker = ({ log }) => {
  const isRunning = log?.startedOn && !log?.finishedOn && log?.statusId === 1;
  const statusClass = isRunning ? 'running' : log?.statusId;

  return (
    <div className={`status-marker status-${statusClass}`} data-title={workflowStatusMap[log?.statusId]}>
      {[0, 10].includes(log?.statusId)}
    </div>
  );
};

export default StatusMarker;
